<template>
  <div class="panel margin--bottom granary-right-panel">
    <bar-card :bg="'border-new'">
      <g-title :bg="'jyzt'">经营主体情况</g-title>
      <div class="content">
        <div class="zt-box flex">
          <img class="zt-bg" src="~images/granary/zzy/jyzt-bg-new.png" alt="" />
          <div class="zt-item" v-for="(item, i) in ztList" :key="i">
            <div class="zt-item-t">
              <span class="num">{{ item.num }}</span>
              <span class="dw">({{ item.unit }})</span>
            </div>
            <div class="zt-item-m">
              {{ item.name }}
            </div>
            <div class="zt-item-b">
              <img :src="item.icon" alt="" />
            </div>
          </div>
        </div>
      </div>
    </bar-card>
  </div>
</template>

<script>
import gTitle from "../../components/gTitle";
export default {
  components: { gTitle },
  data() {
    return {
      ztList: [
        {
          name: "农业龙头企业",
          icon: require("@/assets/images/granary/zzy/jyzt-icon1.png"),
          num: 168,
          unit: "家"
        },
        {
          name: "合作社",
          icon: require("@/assets/images/granary/zzy/jyzt-icon2.png"),
          num: 5640,
          unit: "家"
        },
        {
          name: "家庭农场",
          icon: require("@/assets/images/granary/zzy/jyzt-icon3.png"),
          num: 18828,
          unit: "家"
        }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
.panel
  // height calc(28% - 8px)
  height calc(35% - 8px)
  font-size 0.06rem

.content
  height calc(100% - .2rem)
  position relative
  .zt-box
    width 92%
    height 100%
    margin 0 auto
    align-items flex-end
    justify-content center
    position relative
    .zt-bg
      width 100%
      margin-bottom 20px
    .zt-item
      position absolute
      text-align center
      .zt-item-t
        padding 10px 14px
        border 1px solid #1faaaa
        .num
          color #fff32f
          font-size 20px
        .dw
          color #fff
          font-size 16px
          margin-left 10px
      .zt-item-m
        margin 13px 0 6px 0
        font-size 14px
        color #01ffff
      .zt-item-b
        // position absolute
        // left 0
        // top 60px
        // width 93px
      &:nth-of-type(1)
        left 20px
        bottom 60px
      &:nth-of-type(2)
        left 50%
        transform translateX(-50%)
        bottom 100px
      &:nth-of-type(3)
        right 20px
        bottom 63px
</style>
